// extracted by mini-css-extract-plugin
export var table = "_ui-0";